/*
 * ============================================================
 * GASTER CONTROL - Ballon 3D Visualization (PRODUCTION)
 * ============================================================
 * Rendu 3D du dispositif medical GASTER control BEP
 * (Ballon Extra-Parietal).
 *
 * Architecture :
 *   - Silhouette extraite pixel par pixel du logo GC_triangle.png
 *   - Profil V2 (bombement vertical) avec correction d'overshoot Catmull-Rom
 *   - Asymetrie avant 85% / arriere 30% (ergonomie)
 *   - 7 lames de force pre-galbees embossees sur la face arriere
 *     (capsules type "pillule" en distribution en cloche, base en arc
 *      parallele a la base de la silhouette)
 *   - Mini-logo GC embosse en creux sur la face avant uniquement
 *   - Texture nylon twill (sergé) procedurale, simulant la composition
 *     reelle du dispositif
 *   - Materiau mat satine type silicone medical haut de gamme
 *   - Rotation auto 11 sec / tour, independante du framerate
 *   - Fade-in 0.8s au chargement
 *
 * Integration Shopify :
 *   - Uploader ce fichier dans Assets du theme
 *   - Dans la page (custom-liquid ou theme.liquid) :
 *       <div id="gaster-3d-container" style="display:block; width:100%; height:480px;"></div>
 *       <script src="https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js" defer></script>
 *       <script src="{{ 'gaster-balloon-3d.js' | asset_url }}" defer></script>
 *
 * Resolution maillage : N_ROWS=280, N_COLS=600 (~336k vertex)
 * Resolution texture twill : 1536x1536
 *
 * Dependances : Three.js r128 (via CDN cloudflare)
 * ============================================================
 */
(function() {
function init() {
const container = document.querySelector('.gaster-balloon-stage')
|| document.getElementById('gaster-3d-container');
if (!container) {
return;
}
if (typeof THREE === 'undefined') {
console.warn('[gaster-3d] Three.js not loaded yet, retrying...');
setTimeout(init, 100);
return;
}
if (container.clientWidth === 0 || container.clientHeight === 0) {
if (typeof ResizeObserver !== 'undefined') {
const ro = new ResizeObserver(function(entries) {
for (const e of entries) {
if (e.contentRect.width > 0 && e.contentRect.height > 0) {
ro.disconnect();
startScene(container);
return;
}
}
});
ro.observe(container);
setTimeout(function() {
if (container.clientWidth > 0 && container.clientHeight > 0) {
ro.disconnect();
startScene(container);
}
}, 2000);
} else {
setTimeout(init, 50);
}
return;
}
startScene(container);
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
function startScene(container) {
const W = container.clientWidth, H = container.clientHeight;
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(25, W / H, 0.1, 100);
camera.position.set(0, 0, 14.04);
camera.lookAt(0, 0, 0);
const renderer = new THREE.WebGLRenderer({
antialias: true,
alpha: true,
powerPreference: "high-performance"
});
renderer.setSize(W, H);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 0.85;
renderer.setClearColor(0xfafaf7, 0);
container.appendChild(renderer.domElement);
const HALF_WIDTH_RAW = [
0.0242, 0.0774, 0.1034, 0.1232, 0.1396, 0.1540, 0.1676, 0.1804, 0.1923, 0.2036,
0.2143, 0.2246, 0.2346, 0.2443, 0.2536, 0.2628, 0.2717, 0.2804, 0.2890, 0.2974,
0.3057, 0.3139, 0.3220, 0.3299, 0.3378, 0.3456, 0.3533, 0.3608, 0.3683, 0.3756,
0.3828, 0.3899, 0.3969, 0.4038, 0.4105, 0.4171, 0.4236, 0.4299, 0.4362, 0.4423,
0.4484, 0.4544, 0.4602, 0.4660, 0.4718, 0.4774, 0.4829, 0.4883, 0.4936, 0.4989,
0.5040, 0.5090, 0.5139, 0.5187, 0.5234, 0.5281, 0.5326, 0.5371, 0.5415, 0.5458,
0.5500, 0.5541, 0.5580, 0.5617, 0.5652, 0.5684, 0.5713, 0.5738, 0.5759, 0.5776,
0.5789, 0.5797, 0.5801, 0.5800, 0.5794, 0.5783, 0.5767, 0.5745, 0.5718, 0.5686,
0.5647, 0.5602, 0.5549, 0.5489, 0.5420, 0.5340, 0.5249, 0.5145, 0.5026, 0.4891,
0.4737, 0.4559, 0.4351, 0.4102, 0.3807, 0.3503, 0.3106, 0.2550, 0.1723, 0.0202
];
function gaussianSmooth(arr, sigma) {
const n = arr.length;
const radius = Math.ceil(sigma * 3);
const out = new Array(n);
for (let i = 0; i < n; i++) {
const edgeDist = Math.min(i, n - 1 - i);
const sigmaLocal = sigma * Math.min(1, edgeDist / (sigma * 2));
if (sigmaLocal < 0.05) {
out[i] = arr[i];
continue;
}
const r = Math.ceil(sigmaLocal * 3);
let val = 0, wsum = 0;
for (let k = -r; k <= r; k++) {
const j = i + k;
if (j < 0 || j >= n) continue;
const w = Math.exp(-(k * k) / (2 * sigmaLocal * sigmaLocal));
val += arr[j] * w;
wsum += w;
}
out[i] = val / wsum;
}
return out;
}
const HALF_WIDTH = HALF_WIDTH_RAW;
const TOTAL_HEIGHT = 3.0;
const NP = HALF_WIDTH.length;
function sampleHalfWidth(t) {
const tc = Math.max(0, Math.min(1, t));
const f = tc * (NP - 1);
const i = Math.floor(f);
const frac = f - i;
if (i >= NP - 1) return HALF_WIDTH[NP - 1];
const p0 = HALF_WIDTH[Math.max(0, i - 1)];
const p1 = HALF_WIDTH[i];
const p2 = HALF_WIDTH[i + 1];
const p3 = HALF_WIDTH[Math.min(NP - 1, i + 2)];
const t2 = frac * frac;
const t3 = t2 * frac;
return 0.5 * (
(2 * p1) +
(-p0 + p2) * frac +
(2*p0 - 5*p1 + 4*p2 - p3) * t2 +
(-p0 + 3*p1 - 3*p2 + p3) * t3
);
}
let INFLATE = 0.15;
const CENTROID_Y_NORM = 0.667;
function contourAtAngle(phi) {
const yCentroid = 0.5 - CENTROID_Y_NORM;
const dirX = Math.cos(phi);
const dirY = Math.sin(phi);
function signedDist(r) {
const x = r * dirX;
const y = yCentroid + r * dirY;
const t = 0.5 - y;
if (t < 0 || t > 1) return -1.0;
const hw = sampleHalfWidth(t);
return hw - Math.abs(x);
}
let rLo = 0, rHi = 2.0;
for (let iter = 0; iter < 50; iter++) {
const rMid = (rLo + rHi) / 2;
if (signedDist(rMid) > 0) rLo = rMid;
else rHi = rMid;
if (rHi - rLo < 1e-5) break;
}
const r = (rLo + rHi) / 2;
return { dx: r * dirX, dy: r * dirY, r: r };
}
const N_ROWS = 280;
const N_COLS = 600;
const PROFILE_V2 = [
[0.0000, 0.0000],
[0.0500, 0.0600],
[0.1000, 0.2659],
[0.1500, 0.4943],
[0.2000, 0.6763],
[0.2500, 0.8033],
[0.3000, 0.8955],
[0.3500, 0.9557],
[0.4000, 0.9903],
[0.4500, 0.9996],
[0.5000, 0.9774],
[0.5500, 0.9266],
[0.6000, 0.8567],
[0.6500, 0.7724],
[0.7000, 0.6760],
[0.7500, 0.5759],
[0.8000, 0.4778],
[0.8500, 0.3675],
[0.9000, 0.2380],
[0.9500, 0.0946],
[1.0000, 0.0000]
];
function sampleProfileV2(yNorm) {
yNorm = Math.max(0, Math.min(1, yNorm));
const N = PROFILE_V2.length;
const f = yNorm * (N - 1);
const i = Math.floor(f);
if (i >= N - 1) return PROFILE_V2[N - 1][1];
const frac = f - i;
const p0 = PROFILE_V2[Math.max(0, i - 1)][1];
const p1 = PROFILE_V2[i][1];
const p2 = PROFILE_V2[i + 1][1];
const p3 = PROFILE_V2[Math.min(N - 1, i + 2)][1];
const t2 = frac * frac;
const t3 = t2 * frac;
const v = 0.5 * (
(2 * p1) +
(-p0 + p2) * frac +
(2*p0 - 5*p1 + 4*p2 - p3) * t2 +
(-p0 + 3*p1 - 3*p2 + p3) * t3
);
return Math.max(0, Math.min(1, v));
}
function transverseThickness(xNorm) {
const t = 1 - Math.abs(xNorm);
if (t <= 0) return 0;
if (t >= 1) return 1;
return t * t * t * (t * (t * 6 - 15) + 10);
}
function buildGeometry(inflate) {
const geometry = new THREE.BufferGeometry();
const yCentroidWorld = TOTAL_HEIGHT * (0.5 - CENTROID_Y_NORM);
const maxHw = 0.5884 * TOTAL_HEIGHT;
const thickMax = maxHw * inflate * 2.0 * 1.25;
const frontFraction = 0.85;
const backFraction  = 0.30;
const positions = [];
const nPerFace = N_ROWS * N_COLS;
const halfWidthsByRow = [];
const yByRow = [];
for (let i = 0; i < N_ROWS; i++) {
const yNorm = i / (N_ROWS - 1);
const t = 1 - yNorm;
const hw = sampleHalfWidth(t) * TOTAL_HEIGHT;
const y = TOTAL_HEIGHT * (0.5 - t);
halfWidthsByRow.push(hw);
yByRow.push(y);
}
const MINI_LOGO_SCALE = 0.22;
const MINI_LOGO_MAX_HEIGHT = thickMax * 0.075;
const PROFILE_V2_PEAK_YNORM = 0.45;
const yMiniLogoWorld = TOTAL_HEIGHT * (0.5 - (1 - PROFILE_V2_PEAK_YNORM));
function embossHeight(x, y) {
const dx = x;
const dy = y - yMiniLogoWorld;
const R = Math.sqrt(dx*dx + dy*dy);
if (R < 1e-6) return MINI_LOGO_MAX_HEIGHT;
const phi = Math.atan2(dy, dx);
const { r: rNorm } = contourAtAngle(phi);
const RbordBig = rNorm * TOTAL_HEIGHT;
const RbordMini = RbordBig * MINI_LOGO_SCALE;
const rInMini = R / RbordMini;
if (rInMini >= 1) return 0;
const t = 1 - rInMini;
const ss5 = t * t * t * (t * (t * 6 - 15) + 10);
const h = Math.pow(ss5, 0.25);
return MINI_LOGO_MAX_HEIGHT * h;
}
const NUM_BLADES = 7;
const BLADE_HEIGHT_MAX = thickMax * 0.048;
const BLADE_WIDTH = TOTAL_HEIGHT * 0.045;
const BLADE_SPACING = TOTAL_HEIGHT * 0.114;
const LEN_CENTRAL = 2.25;
const yCenterMid = -0.075;
const yBladesBottomCenter = yCenterMid - LEN_CENTRAL * 0.5;
const yBladesTopCenter    = yCenterMid + LEN_CENTRAL * 0.5;
const BLADE_LENGTHS = [0.90, 1.35, 1.80, LEN_CENTRAL, 1.80, 1.35, 0.90];
const BASE_ARC_DELTA = 0.10;
const BASE_ARC_OFFSETS = [3, 2, 1, 0, 1, 2, 3];
const yLateralBaseRef = -1.20;
function ss5(u) {
return u * u * u * (u * (u * 6 - 15) + 10);
}
function bladesHeight(x, y) {
const halfW = BLADE_WIDTH * 0.5;
const bevelW = BLADE_WIDTH * 0.20;
let maxH = 0;
for (let k = 0; k < NUM_BLADES; k++) {
const bladeIndex = k - (NUM_BLADES - 1) / 2;
const xCenter = bladeIndex * BLADE_SPACING;
let yBot, yTop;
if (bladeIndex === 0) {
yBot = yBladesBottomCenter;
yTop = yBladesTopCenter;
} else {
yBot = yLateralBaseRef + BASE_ARC_OFFSETS[k] * BASE_ARC_DELTA;
yTop = yBot + BLADE_LENGTHS[k];
}
const yMid = (yTop + yBot) * 0.5;
const halfL = (yTop - yBot) * 0.5;
const dx = x - xCenter;
const dy = y - yMid;
const absDx = Math.abs(dx);
const absDy = Math.abs(dy);
const flatHalfLength = halfL - halfW;
let distToAxis;
if (flatHalfLength <= 0) {
distToAxis = Math.sqrt(dx*dx + dy*dy) - 0;
} else if (absDy <= flatHalfLength) {
distToAxis = absDx;
} else {
const dyCap = absDy - flatHalfLength;
distToAxis = Math.sqrt(dx*dx + dyCap*dyCap);
}
if (distToAxis >= halfW) continue;
let profile;
if (distToAxis <= halfW - bevelW) {
profile = 1.0;
} else {
const u = (halfW - distToAxis) / bevelW;
profile = ss5(u);
}
const h = BLADE_HEIGHT_MAX * profile;
if (h > maxH) maxH = h;
}
return maxH;
}
for (let i = 0; i < N_ROWS; i++) {
const yNorm = i / (N_ROWS - 1);
const hw = halfWidthsByRow[i];
const y = yByRow[i];
const profileV = sampleProfileV2(yNorm);
for (let j = 0; j < N_COLS; j++) {
const xNorm = (j / (N_COLS - 1)) * 2 - 1;
const x = xNorm * hw;
const transverseT = transverseThickness(xNorm);
const zDome = thickMax * frontFraction * profileV * transverseT;
const z = zDome - embossHeight(x, y);
positions.push(x, y, z);
}
}
const nFront = nPerFace;
for (let i = 0; i < N_ROWS; i++) {
const yNorm = i / (N_ROWS - 1);
const hw = halfWidthsByRow[i];
const y = yByRow[i];
const profileV = sampleProfileV2(yNorm);
for (let j = 0; j < N_COLS; j++) {
const xNorm = (j / (N_COLS - 1)) * 2 - 1;
const x = xNorm * hw;
const transverseT = transverseThickness(xNorm);
const zDome = -thickMax * backFraction * profileV * transverseT;
const z = zDome - bladesHeight(x, y);
positions.push(x, y, z);
}
}
const nTotal = 2 * nFront;
const indices = [];
function iFront(i, j) { return i * N_COLS + j; }
function iBack(i, j)  { return nFront + i * N_COLS + j; }
for (let i = 0; i < N_ROWS - 1; i++) {
for (let j = 0; j < N_COLS - 1; j++) {
const a = iFront(i,   j  );
const b = iFront(i,   j+1);
const c = iFront(i+1, j  );
const d = iFront(i+1, j+1);
indices.push(a, b, d);
indices.push(a, d, c);
}
}
for (let i = 0; i < N_ROWS - 1; i++) {
for (let j = 0; j < N_COLS - 1; j++) {
const a = iBack(i,   j  );
const b = iBack(i,   j+1);
const c = iBack(i+1, j  );
const d = iBack(i+1, j+1);
indices.push(a, d, b);
indices.push(a, c, d);
}
}
const baseColor = new THREE.Color(GREEN);
const seamColor = new THREE.Color(GREEN).multiplyScalar(0.62);
const aoColor   = new THREE.Color(GREEN).multiplyScalar(0.35);
function computeColor(ins) {
const seamBand = 0.12;
const aoBand = 0.025;
let seamMix = 1.0;
if (ins < seamBand) {
const u = ins / seamBand;
seamMix = u * u * u * (u * (u * 6 - 15) + 10);
}
let r = seamColor.r + (baseColor.r - seamColor.r) * seamMix;
let g = seamColor.g + (baseColor.g - seamColor.g) * seamMix;
let b = seamColor.b + (baseColor.b - seamColor.b) * seamMix;
if (ins < aoBand) {
const u = ins / aoBand;
const aoIntensity = 1 - (u * u * (3 - 2 * u));
r = r * (1 - aoIntensity * 0.6) + aoColor.r * aoIntensity * 0.6;
g = g * (1 - aoIntensity * 0.6) + aoColor.g * aoIntensity * 0.6;
b = b * (1 - aoIntensity * 0.6) + aoColor.b * aoIntensity * 0.6;
}
return [r, g, b];
}
function insideness(i, j) {
const yNorm = i / (N_ROWS - 1);
const xNorm = (j / (N_COLS - 1)) * 2 - 1;
const pv = sampleProfileV2(yNorm);
const tt = transverseThickness(xNorm);
return pv * tt;
}
const colors = [];
for (let i = 0; i < N_ROWS; i++) {
for (let j = 0; j < N_COLS; j++) {
const ins = insideness(i, j);
const c = computeColor(ins);
colors.push(c[0], c[1], c[2]);
}
}
for (let i = 0; i < N_ROWS; i++) {
for (let j = 0; j < N_COLS; j++) {
const ins = insideness(i, j);
const c = computeColor(ins);
colors.push(c[0], c[1], c[2]);
}
}
geometry.setIndex(indices);
geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
const UV_SCALE_X = 0.30;
const UV_SCALE_V = TOTAL_HEIGHT * UV_SCALE_X;
const uvs = [];
for (let face = 0; face < 2; face++) {
for (let i = 0; i < N_ROWS; i++) {
const v = (i / (N_ROWS - 1)) * UV_SCALE_V;
for (let j = 0; j < N_COLS; j++) {
const idx = (face * nPerFace + i * N_COLS + j) * 3;
const x = positions[idx + 0];
uvs.push(x * UV_SCALE_X, v);
}
}
}
geometry.setAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
geometry.computeVertexNormals();
return geometry;
}
const GREEN = 0x77C6A2;
function makeTwillTextures(threadsPerSide) {
const size = 1536;
const cellSize = size / threadsPerSide;
const heightCanvas = document.createElement('canvas');
heightCanvas.width = size;
heightCanvas.height = size;
const hctx = heightCanvas.getContext('2d');
hctx.fillStyle = '#808080';
hctx.fillRect(0, 0, size, size);
for (let row = 0; row < threadsPerSide + 1; row++) {
for (let col = 0; col < threadsPerSide + 1; col++) {
const phase = (col - row) % 3;
const adjustedPhase = ((phase % 3) + 3) % 3;
const isHigh = adjustedPhase < 2;
const cx = col * cellSize;
const cy = row * cellSize;
if (isHigh) {
const grad = hctx.createRadialGradient(
cx + cellSize * 0.5, cy + cellSize * 0.5, 0,
cx + cellSize * 0.5, cy + cellSize * 0.5, cellSize * 0.7
);
grad.addColorStop(0.00, '#a0a0a0');
grad.addColorStop(0.60, '#909090');
grad.addColorStop(1.00, '#707070');
hctx.fillStyle = grad;
} else {
hctx.fillStyle = '#606060';
}
hctx.fillRect(cx, cy, cellSize + 1, cellSize + 1);
}
}
const srcData = hctx.getImageData(0, 0, size, size).data;
const normCanvas = document.createElement('canvas');
normCanvas.width = size;
normCanvas.height = size;
const nctx = normCanvas.getContext('2d');
const normImage = nctx.createImageData(size, size);
const ndata = normImage.data;
const strength = 1.5;
for (let y = 0; y < size; y++) {
for (let x = 0; x < size; x++) {
const xl = (x - 1 + size) % size;
const xr = (x + 1) % size;
const yu = (y - 1 + size) % size;
const yd = (y + 1) % size;
const hL = srcData[(y * size + xl) * 4] / 255;
const hR = srcData[(y * size + xr) * 4] / 255;
const hU = srcData[(yu * size + x) * 4] / 255;
const hD = srcData[(yd * size + x) * 4] / 255;
const dx = (hR - hL) * strength;
const dy = (hD - hU) * strength;
const dz = 1.0;
const len = Math.sqrt(dx * dx + dy * dy + dz * dz);
const nx = dx / len;
const ny = dy / len;
const nz = dz / len;
const i = (y * size + x) * 4;
ndata[i    ] = Math.round((nx * 0.5 + 0.5) * 255);
ndata[i + 1] = Math.round((-ny * 0.5 + 0.5) * 255);
ndata[i + 2] = Math.round((nz * 0.5 + 0.5) * 255);
ndata[i + 3] = 255;
}
}
nctx.putImageData(normImage, 0, 0);
const normalTex = new THREE.CanvasTexture(normCanvas);
normalTex.wrapS = THREE.RepeatWrapping;
normalTex.wrapT = THREE.RepeatWrapping;
normalTex.anisotropy = 16;
return { normalTex: normalTex };
}
const TWILL_DENSITY = 250;
const twillTextures = makeTwillTextures(TWILL_DENSITY);
const solidMaterial = new THREE.MeshPhysicalMaterial({
vertexColors: true,
roughness: 0.65,
metalness: 0.0,
clearcoat: 0.25,
clearcoatRoughness: 0.60,
reflectivity: 0.10,
side: THREE.DoubleSide,
flatShading: false,
normalMap: twillTextures.normalTex,
normalScale: new THREE.Vector2(1.0, 1.0),
transparent: false,
opacity: 1.0,
});
let geometry = buildGeometry(INFLATE);
const mesh = new THREE.Mesh(geometry, solidMaterial);
scene.add(mesh);
function makeShadowTexture() {
const size = 256;
const canvas = document.createElement('canvas');
canvas.width = size;
canvas.height = size;
const ctx = canvas.getContext('2d');
ctx.clearRect(0, 0, size, size);
const grad = ctx.createRadialGradient(size/2, size/2, 0, size/2, size/2, size/2);
grad.addColorStop(0,   'rgba(0, 0, 0, 0.22)');
grad.addColorStop(0.4, 'rgba(0, 0, 0, 0.12)');
grad.addColorStop(0.7, 'rgba(0, 0, 0, 0.04)');
grad.addColorStop(1,   'rgba(0, 0, 0, 0.00)');
ctx.fillStyle = grad;
ctx.fillRect(0, 0, size, size);
const tex = new THREE.CanvasTexture(canvas);
tex.needsUpdate = true;
return tex;
}
const shadowTex = makeShadowTexture();
const shadowMat = new THREE.MeshBasicMaterial({
map: shadowTex,
transparent: true,
depthWrite: false,
});
const shadowGeo = new THREE.PlaneGeometry(TOTAL_HEIGHT * 1.6, TOTAL_HEIGHT * 0.5);
const shadow = new THREE.Mesh(shadowGeo, shadowMat);
shadow.rotation.x = -Math.PI / 2;
shadow.position.y = -TOTAL_HEIGHT * 0.52;
scene.add(shadow);
scene.add(new THREE.HemisphereLight(0xffffff, 0xf0efe8, 0.22));
scene.add(new THREE.AmbientLight(0xffffff, 0.06));
const key = new THREE.DirectionalLight(0xffffff, 0.85);
key.position.set(-3, 5, 6);
scene.add(key);
const fill = new THREE.DirectionalLight(0xffffff, 0.28);
fill.position.set(4, 0, 3);
scene.add(fill);
const rim = new THREE.DirectionalLight(0xffffff, 0.35);
rim.position.set(2, -1, -5);
scene.add(rim);
const rotating = true;
function resize() {
const newW = container.clientWidth, newH = container.clientHeight;
if (newW === 0 || newH === 0) return;
camera.aspect = newW / newH;
camera.updateProjectionMatrix();
renderer.setSize(newW, newH);
}
window.addEventListener('resize', resize);
if (typeof ResizeObserver !== 'undefined') {
const ro = new ResizeObserver(resize);
ro.observe(container);
}
container.style.cursor = "default";
const INTRO_DURATION = 0.8;
const startTime = performance.now() / 1000;
let introCompleted = false;
solidMaterial.transparent = true;
solidMaterial.opacity = 0;
function smoothstep(x) {
x = Math.max(0, Math.min(1, x));
return x * x * (3 - 2 * x);
}
let lastFrameTime = 0;
const ROTATION_SPEED = (2 * Math.PI) / 11.0;
function animate() {
requestAnimationFrame(animate);
const now = performance.now() / 1000;
const elapsed = now - startTime;
if (!introCompleted) {
if (elapsed < INTRO_DURATION) {
const t = elapsed / INTRO_DURATION;
solidMaterial.opacity = smoothstep(t);
} else {
solidMaterial.opacity = 1.0;
solidMaterial.transparent = false;
solidMaterial.needsUpdate = true;
introCompleted = true;
}
}
if (rotating) {
const dt = lastFrameTime ? (now - lastFrameTime) : 0;
mesh.rotation.y += ROTATION_SPEED * dt;
}
lastFrameTime = now;
renderer.render(scene, camera);
}
animate();
}
})();
